import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../../utils/api';

/* ── Avatar circle with HSL gradient from name ── */
function Avatar({ name, size = 36 }) {
  const hue = (name || 'A').charCodeAt(0) * 137 % 360;
  const initials = (name || '?').split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();
  return (
    <div style={{
      width:size, height:size, borderRadius:'50%', flexShrink:0,
      background:`linear-gradient(135deg, hsl(${hue},55%,60%), hsl(${(hue+40)%360},55%,35%))`,
      display:'flex', alignItems:'center', justifyContent:'center',
      color:'#fff', fontWeight:600, fontSize:size*0.35,
      fontFamily:"'Inter', system-ui, sans-serif",
    }}>{initials}</div>
  );
}

/* ─────────────────────────────────────────────
   CUSTOMERS
───────────────────────────────────────────── */
export function CustomersAdmin() {
  const [customers, setCustomers] = useState([]);
  const [search,    setSearch]    = useState('');
  const [page,      setPage]      = useState(1);
  const [pagination,setPag]       = useState({});
  const [loading,   setLoading]   = useState(true);
  const [selected,  setSelected]  = useState(null);

  useEffect(() => {
    setLoading(true);
    const p = new URLSearchParams({ page, limit:15 });
    if (search) p.set('search', search);
    api.get(`/admin/customers?${p}`).then(r => { setCustomers(r.data.data||[]); setPag(r.data.pagination||{}); }).finally(()=>setLoading(false));
  }, [page, search]);

  return (
    <div style={{ fontFamily:'var(--font-sans)' }}>
      <div style={{ marginBottom:28 }}>
        <p style={{ fontSize:10.5, letterSpacing:'1.5px', textTransform:'uppercase', color:'var(--muted)', marginBottom:4, fontWeight:500 }}>CRM</p>
        <h1 style={{ fontFamily:'var(--font-serif)', fontSize:34, fontWeight:400, letterSpacing:'-0.5px', color:'var(--white)', margin:0 }}>Customers</h1>
        <p style={{ fontSize:13, color:'var(--muted)', marginTop:6 }}>{pagination.total||0} registered buyers</p>
      </div>

      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:18, marginBottom:20, boxShadow:'var(--shadow-sm)' }}>
        <div style={{ position:'relative', maxWidth:340 }}>
          <div style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--muted)', pointerEvents:'none' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
          </div>
          <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1)}} className="form-input" placeholder="Search by name or email…" style={{ paddingLeft:36 }} />
        </div>
      </div>

      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', overflow:'hidden', boxShadow:'var(--shadow-sm)' }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Customer</th><th className="col-mob-hide">Country</th><th>Orders</th><th className="col-mob-hide">Lifetime Spend</th><th className="col-mob-hide">Joined</th><th></th></tr></thead>
            <tbody>
              {loading ? [...Array(5)].map((_,i)=><tr key={i}><td colSpan={6}><div className="skeleton" style={{height:20,margin:'4px 0'}}/></td></tr>)
              : customers.map(c => (
                <tr key={c.id}>
                  <td>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <Avatar name={`${c.first_name} ${c.last_name}`} />
                      <div>
                        <p style={{ fontSize:13, color:'var(--white)', fontWeight:500 }}>{c.first_name} {c.last_name}</p>
                        <p style={{ fontSize:11, color:'var(--muted)' }}>{c.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="col-mob-hide" style={{ color:'var(--muted)', fontSize:13 }}>{c.country||'—'}</td>
                  <td><span style={{ fontFamily:'var(--font-serif)', fontSize:14, color:'var(--gold)' }}>{c.total_orders}</span></td>
                  <td className="col-mob-hide" style={{ color:'var(--white)', fontWeight:500 }}>${Number(c.total_spent_usd||0).toLocaleString()}</td>
                  <td className="col-mob-hide" style={{ color:'var(--muted)', fontSize:12 }}>{new Date(c.created_at).toLocaleDateString()}</td>
                  <td>
                    <button onClick={()=>setSelected(c)} style={{ fontSize:12, color:'var(--gold)', background:'none', border:'none', cursor:'pointer', fontFamily:'var(--font-sans)' }}>View →</button>
                  </td>
                </tr>
              ))}
              {!loading&&!customers.length&&<tr><td colSpan={6} style={{textAlign:'center',color:'var(--muted)',padding:'48px 0'}}>No customers yet</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {pagination.pages>1 && <div className="pagination">{[...Array(pagination.pages)].map((_,i)=><button key={i} className={`page-btn${i+1===page?' active':''}`} onClick={()=>setPage(i+1)}>{i+1}</button>)}</div>}

      {selected && (
        <div className="modal-overlay" onClick={()=>setSelected(null)}>
          <div className="modal-box" onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:22 }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <Avatar name={`${selected.first_name} ${selected.last_name}`} size={44} />
                <div>
                  <h3 style={{ fontFamily:'var(--font-serif)', fontSize:22, fontWeight:400, color:'var(--white)', margin:0 }}>{selected.first_name} {selected.last_name}</h3>
                  <p style={{ fontSize:12, color:'var(--muted)', marginTop:2 }}>{selected.email}</p>
                </div>
              </div>
              <button onClick={()=>setSelected(null)} style={{ color:'var(--muted)', fontSize:20, lineHeight:1 }}>✕</button>
            </div>
            {[['Phone',selected.phone||'—'],['Country',selected.country||'—'],['City',selected.city||'—'],['Total Orders',selected.total_orders],['Total Spent',`$${Number(selected.total_spent_usd||0).toLocaleString()} USD`],['Member Since',new Date(selected.created_at).toLocaleDateString()]].map(([k,v])=>(
              <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'11px 0', borderBottom:'1px solid var(--border)' }}>
                <span style={{ fontSize:11, color:'var(--muted)', letterSpacing:'0.8px', textTransform:'uppercase', fontWeight:500 }}>{k}</span>
                <span style={{ fontSize:13, color:'var(--white)', fontWeight:500 }}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   ENQUIRIES (two-pane inbox)
───────────────────────────────────────────── */
export function EnquiriesAdmin() {
  const [enquiries, setEnquiries] = useState([]);
  const [status,    setStatus]    = useState('');
  const [page,      setPage]      = useState(1);
  const [pagination,setPag]       = useState({});
  const [selected,  setSelected]  = useState(null);
  const [reply,     setReply]     = useState('');
  const [sending,   setSending]   = useState(false);
  const [loading,   setLoading]   = useState(true);

  const load = () => {
    setLoading(true);
    const p = new URLSearchParams({ page, limit:20 });
    if (status) p.set('status', status);
    api.get(`/admin/enquiries?${p}`).then(r => { setEnquiries(r.data.data||[]); setPag(r.data.pagination||{}); }).finally(()=>setLoading(false));
  };
  useEffect(() => { load(); }, [page, status]);

  const openEnquiry = async (e) => {
    setSelected(e); setReply('');
    if (e.status === 'new') { await api.put(`/admin/enquiries/${e.id}/status`, { status:'read' }); load(); }
  };

  const sendReply = async () => {
    if (!reply.trim()) return;
    setSending(true);
    try {
      await api.put(`/admin/enquiries/${selected.id}/reply`, { reply });
      toast.success('Reply sent via email!');
      setSelected(null); load();
    } catch { toast.error('Failed to send reply'); }
    finally { setSending(false); }
  };

  const STATUSES = ['','new','read','replied','closed'];

  return (
    <div style={{ fontFamily:'var(--font-sans)' }}>
      <div style={{ marginBottom:24 }}>
        <p style={{ fontSize:10.5, letterSpacing:'1.5px', textTransform:'uppercase', color:'var(--muted)', marginBottom:4, fontWeight:500 }}>Inbox</p>
        <h1 style={{ fontFamily:'var(--font-serif)', fontSize:34, fontWeight:400, letterSpacing:'-0.5px', color:'var(--white)', margin:0 }}>Enquiries</h1>
      </div>

      <div className="enquiry-shell" style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', overflow:'hidden', boxShadow:'var(--shadow-sm)', display:'flex', height:620 }}>
        {/* List pane */}
        <div className="enquiry-list-pane" style={{ width:360, flexShrink:0, borderRight:'1px solid var(--border)', display:'flex', flexDirection:'column' }}>
          <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)', display:'flex', gap:6, flexWrap:'wrap' }}>
            {STATUSES.map(s => (
              <button key={s} onClick={()=>{setStatus(s);setPage(1);}} style={{
                padding:'4px 10px', borderRadius:999, fontSize:11,
                fontFamily:'var(--font-sans)', cursor:'pointer',
                background: status===s ? '#0c0c10' : 'transparent',
                color: status===s ? '#ecd9b1' : 'var(--muted)',
                border: status===s ? '1px solid rgba(201,169,110,0.3)' : '1px solid var(--border)',
                textTransform:'capitalize',
              }}>{s||'All'}</button>
            ))}
          </div>
          <div style={{ flex:1, overflowY:'auto' }}>
            {loading ? [...Array(5)].map((_,i)=><div key={i} className="skeleton" style={{ height:72, margin:'8px 12px', borderRadius:6 }} />)
            : enquiries.map(e => (
              <div key={e.id} onClick={()=>openEnquiry(e)} style={{
                padding:'14px 16px', cursor:'pointer', position:'relative',
                background: selected?.id===e.id ? 'rgba(201,169,110,0.08)' : 'transparent',
                borderLeft: selected?.id===e.id ? '3px solid var(--gold)' : '3px solid transparent',
                borderBottom:'1px solid var(--border)', transition:'background 0.12s',
              }}
              onMouseEnter={ev=>{if(selected?.id!==e.id)ev.currentTarget.style.background='var(--surface2)'}}
              onMouseLeave={ev=>{if(selected?.id!==e.id)ev.currentTarget.style.background='transparent'}}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                    {e.status==='new' && <div style={{ width:7, height:7, borderRadius:'50%', background:'var(--gold)', flexShrink:0 }} />}
                    <p style={{ fontSize:13, color:'var(--white)', fontWeight:e.status==='new'?600:400 }}>{e.name}</p>
                  </div>
                  <span style={{ fontSize:10, color:'var(--muted)', flexShrink:0, marginLeft:8 }}>{new Date(e.created_at).toLocaleDateString()}</span>
                </div>
                {e.gem_name && <p style={{ fontSize:11, color:'var(--gold)', marginTop:3, paddingLeft:e.status==='new'?15:0 }}>Re: {e.gem_name}</p>}
                <p style={{ fontSize:12, color:'var(--muted)', marginTop:4, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', paddingLeft:e.status==='new'?15:0 }}>{e.message?.slice(0,80)}</p>
              </div>
            ))}
            {!loading&&!enquiries.length&&<p style={{ textAlign:'center', color:'var(--muted)', padding:'40px 20px', fontSize:13 }}>No enquiries found</p>}
          </div>
        </div>

        {/* Reading pane */}
        {selected ? (
          <div style={{ flex:1, display:'flex', flexDirection:'column', overflow:'hidden' }}>
            <div style={{ padding:'16px 22px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div>
                <h3 style={{ fontFamily:'var(--font-serif)', fontSize:18, fontWeight:400, color:'var(--white)', margin:0 }}>{selected.name}</h3>
                <p style={{ fontSize:12, color:'var(--muted)', marginTop:2 }}>{selected.email} · {new Date(selected.created_at).toLocaleString()}</p>
                {selected.gem_name && <span className="badge badge-gold" style={{ marginTop:6, display:'inline-flex' }}>Re: {selected.gem_name}</span>}
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={()=>setSelected(null)} style={{ color:'var(--muted)', fontSize:18, padding:4 }}>✕</button>
              </div>
            </div>
            <div style={{ flex:1, overflowY:'auto', padding:22 }}>
              <div style={{ padding:'16px 20px', background:'var(--surface2)', borderRadius:8, marginBottom:18, border:'1px solid var(--border)' }}>
                <p style={{ fontSize:11, color:'var(--gold)', marginBottom:10, letterSpacing:'0.8px', textTransform:'uppercase', fontWeight:500 }}>Customer Message</p>
                <p style={{ fontSize:14, color:'var(--white)', lineHeight:1.7, whiteSpace:'pre-wrap' }}>{selected.message}</p>
              </div>
              {selected.reply && (
                <div style={{ padding:'16px 20px', background:'rgba(31,122,77,0.06)', borderRadius:8, marginBottom:18, border:'1px solid rgba(31,122,77,0.2)' }}>
                  <p style={{ fontSize:11, color:'var(--success)', marginBottom:10, letterSpacing:'0.8px', textTransform:'uppercase', fontWeight:500 }}>Previous Reply</p>
                  <p style={{ fontSize:13, color:'var(--white)', lineHeight:1.7, whiteSpace:'pre-wrap' }}>{selected.reply}</p>
                </div>
              )}
            </div>
            <div style={{ padding:'16px 22px', borderTop:'1px solid var(--border)', display:'flex', gap:10 }}>
              <input value={reply} onChange={e=>setReply(e.target.value)} className="form-input" placeholder="Write a reply…" style={{ flex:1 }}
                onKeyDown={e=>e.key==='Enter'&&!e.shiftKey&&(e.preventDefault(),sendReply())} />
              <button onClick={sendReply} disabled={sending||!reply.trim()} className="btn btn-gold">
                {sending?'Sending…':'Send →'}
              </button>
            </div>
          </div>
        ) : (
          <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', color:'var(--muted)', fontSize:14 }}>
            Select an enquiry to read
          </div>
        )}
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SEO ADMIN
───────────────────────────────────────────── */
export function SeoAdmin() {
  const [pages,    setPages]    = useState([]);
  const [selected, setSelected] = useState(null);
  const [form,     setForm]     = useState({});
  const [saving,   setSaving]   = useState(false);
  const [settings, setSettings] = useState({});
  const [tab,      setTab]      = useState('pages');

  useEffect(() => {
    api.get('/admin/seo').then(r => setPages(r.data.data||[]));
    api.get('/admin/seo/settings').then(r => {
      const map = {};
      (r.data.data||[]).forEach(s => { map[s.setting_key] = s.value||''; });
      setSettings(map);
    });
  }, []);

  const openPage = p => { setSelected(p); setForm({...p}); };

  const savePage = async () => {
    setSaving(true);
    try { await api.put(`/admin/seo/${selected.page_key}`, form); toast.success('SEO saved!'); api.get('/admin/seo').then(r => setPages(r.data.data||[])); }
    catch { toast.error('Save failed'); }
    finally { setSaving(false); }
  };

  const saveSettings = async () => {
    setSaving(true);
    try { await api.put('/admin/seo/settings', settings); toast.success('Settings saved!'); }
    catch { toast.error('Save failed'); }
    finally { setSaving(false); }
  };

  const charCount = (str, max) => {
    const len = (str||'').length;
    return <span style={{ fontSize:10, color:len>max?'var(--danger)':len>max*0.85?'var(--warning)':'var(--muted)', marginLeft:8 }}>{len}/{max}</span>;
  };

  const searchPreview = {
    url: form.canonical_url || 'https://ceylongems.com',
    title: form.meta_title || form.page_name || 'Ceylon Gems',
    desc: form.meta_description || '',
  };

  return (
    <div style={{ fontFamily:'var(--font-sans)' }}>
      <div style={{ marginBottom:28 }}>
        <p style={{ fontSize:10.5, letterSpacing:'1.5px', textTransform:'uppercase', color:'var(--muted)', marginBottom:4, fontWeight:500 }}>Optimization</p>
        <h1 style={{ fontFamily:'var(--font-serif)', fontSize:34, fontWeight:400, letterSpacing:'-0.5px', color:'var(--white)', margin:0 }}>SEO Manager</h1>
        <p style={{ fontSize:13, color:'var(--muted)', marginTop:6 }}>Manage meta tags, Open Graph, sitemaps, and analytics</p>
      </div>

      <div className="pill-tabs" style={{ marginBottom:24 }}>
        {[['pages','Page SEO'],['settings','Analytics & Tools']].map(([k,l])=>(
          <button key={k} onClick={()=>setTab(k)} className={tab===k?'is-active':''}>{l}</button>
        ))}
      </div>

      {tab === 'pages' && (
        <div className="admin-form-grid" style={{ display:'grid', gridTemplateColumns:'260px 1fr', gap:20 }}>
          <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', overflow:'hidden', boxShadow:'var(--shadow-sm)', height:'fit-content' }}>
            {pages.map((p, i) => (
              <button key={p.page_key} onClick={()=>openPage(p)} style={{
                display:'block', width:'100%', padding:'14px 18px', textAlign:'left',
                borderBottom: i<pages.length-1?'1px solid var(--border)':'none',
                background: selected?.page_key===p.page_key?'rgba(201,169,110,0.08)':'transparent',
                borderLeft: selected?.page_key===p.page_key?'3px solid var(--gold)':'3px solid transparent',
                transition:'background 0.12s', cursor:'pointer',
              }}
              onMouseEnter={e=>{if(selected?.page_key!==p.page_key)e.currentTarget.style.background='var(--surface2)'}}
              onMouseLeave={e=>{if(selected?.page_key!==p.page_key)e.currentTarget.style.background='transparent'}}>
                <p style={{ fontSize:13, color:selected?.page_key===p.page_key?'var(--gold)':'var(--white)', fontWeight:500 }}>{p.page_name}</p>
                <p style={{ fontSize:11, color:'var(--muted)', marginTop:2 }}>/{p.page_key}</p>
              </button>
            ))}
          </div>

          {selected ? (
            <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
              <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:28, boxShadow:'var(--shadow-sm)' }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:22 }}>
                  <h3 style={{ fontFamily:'var(--font-serif)', fontSize:20, fontWeight:400, color:'var(--white)', margin:0 }}>{selected.page_name}</h3>
                  <button onClick={savePage} disabled={saving} className="btn btn-gold btn-sm">{saving?'Saving…':'Save SEO'}</button>
                </div>

                <p style={{ fontSize:10.5, letterSpacing:'2px', textTransform:'uppercase', color:'var(--gold)', marginBottom:16, fontWeight:500 }}>Meta Tags</p>
                <div className="form-group"><label className="form-label">Meta Title {charCount(form.meta_title,70)}</label>
                  <input value={form.meta_title||''} onChange={e=>setForm({...form,meta_title:e.target.value})} className="form-input" placeholder="Page title (max 70 chars)" maxLength={70} />
                </div>
                <div className="form-group"><label className="form-label">Meta Description {charCount(form.meta_description,160)}</label>
                  <textarea value={form.meta_description||''} onChange={e=>setForm({...form,meta_description:e.target.value})} className="form-input" rows={3} placeholder="Meta description (max 160 chars)" maxLength={160} />
                </div>
                <div className="form-group"><label className="form-label">Meta Keywords</label>
                  <input value={form.meta_keywords||''} onChange={e=>setForm({...form,meta_keywords:e.target.value})} className="form-input" placeholder="ceylon sapphire, natural gemstones…" />
                </div>
                <div className="grid-2">
                  <div className="form-group"><label className="form-label">Canonical URL</label>
                    <input value={form.canonical_url||''} onChange={e=>setForm({...form,canonical_url:e.target.value})} className="form-input" placeholder="https://ceylongems.com/" />
                  </div>
                  <div className="form-group"><label className="form-label">Robots</label>
                    <select value={form.robots||'index, follow'} onChange={e=>setForm({...form,robots:e.target.value})} className="form-select">
                      <option>index, follow</option><option>noindex, nofollow</option><option>index, nofollow</option><option>noindex, follow</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Google search preview */}
              <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:24, boxShadow:'var(--shadow-sm)' }}>
                <p style={{ fontSize:10.5, letterSpacing:'2px', textTransform:'uppercase', color:'var(--muted)', marginBottom:16, fontWeight:500 }}>Search Preview</p>
                <div style={{ padding:16, background:'var(--surface2)', borderRadius:8, border:'1px solid var(--border)' }}>
                  <p style={{ fontSize:12, color:'#4d8a4d', marginBottom:4 }}>{searchPreview.url}</p>
                  <p style={{ fontSize:18, color:'#1a73e8', marginBottom:4, fontFamily:'Arial, sans-serif', lineHeight:1.2 }}>{searchPreview.title}</p>
                  <p style={{ fontSize:13, color:'#4d4d4d', lineHeight:1.5, fontFamily:'Arial, sans-serif' }}>{searchPreview.desc || 'No meta description set.'}</p>
                </div>
              </div>

              <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:28, boxShadow:'var(--shadow-sm)' }}>
                <p style={{ fontSize:10.5, letterSpacing:'2px', textTransform:'uppercase', color:'var(--gold)', marginBottom:16, fontWeight:500 }}>Open Graph (Social)</p>
                <div className="form-group"><label className="form-label">OG Title {charCount(form.og_title,100)}</label>
                  <input value={form.og_title||''} onChange={e=>setForm({...form,og_title:e.target.value})} className="form-input" placeholder="Title for social sharing" maxLength={100} />
                </div>
                <div className="form-group"><label className="form-label">OG Description {charCount(form.og_description,200)}</label>
                  <textarea value={form.og_description||''} onChange={e=>setForm({...form,og_description:e.target.value})} className="form-input" rows={2} placeholder="Description for social sharing" maxLength={200} />
                </div>
                <div className="form-group"><label className="form-label">OG Image URL</label>
                  <input value={form.og_image||''} onChange={e=>setForm({...form,og_image:e.target.value})} className="form-input" placeholder="https://ceylongems.com/og-image.jpg (1200×630px)" />
                </div>
                <div className="form-group"><label className="form-label">JSON-LD Schema Markup</label>
                  <textarea value={form.structured_data||''} onChange={e=>setForm({...form,structured_data:e.target.value})} className="form-input" rows={4} style={{ fontFamily:'monospace', fontSize:12 }} placeholder='{"@context":"https://schema.org","@type":"Store"}' />
                </div>
              </div>
            </div>
          ) : (
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', color:'var(--muted)', fontSize:14, minHeight:300, boxShadow:'var(--shadow-sm)' }}>
              Select a page to edit its SEO settings
            </div>
          )}
        </div>
      )}

      {tab === 'settings' && (
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:32, maxWidth:720, boxShadow:'var(--shadow-sm)' }}>
          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:28 }}>
            <h3 style={{ fontFamily:'var(--font-serif)', fontSize:22, fontWeight:400, color:'var(--white)', margin:0 }}>Analytics & Verification</h3>
            <button onClick={saveSettings} disabled={saving} className="btn btn-gold btn-sm">{saving?'Saving…':'Save Settings'}</button>
          </div>
          {[
            { key:'google_analytics',     label:'Google Analytics 4 ID',        ph:'G-XXXXXXXXXX',       desc:'Your GA4 property measurement ID.' },
            { key:'google_search_console',label:'Search Console Verification',   ph:'google-site-verification=…', desc:'Meta content value from Google Search Console.' },
            { key:'facebook_pixel',       label:'Facebook / Meta Pixel ID',      ph:'1234567890123456',  desc:'Numeric Pixel ID for Facebook ad tracking.' },
          ].map(({ key, label, ph, desc }) => (
            <div key={key} className="form-group">
              <label className="form-label">{label}</label>
              <input value={settings[key]||''} onChange={e=>setSettings({...settings,[key]:e.target.value})} className="form-input" placeholder={ph} />
              <p style={{ fontSize:11, color:'var(--muted)', marginTop:6, lineHeight:1.6 }}>{desc}</p>
            </div>
          ))}
          <div className="form-group">
            <label className="form-label">robots.txt Content</label>
            <textarea value={settings.robots_txt||''} onChange={e=>setSettings({...settings,robots_txt:e.target.value})} className="form-input" rows={6} style={{ fontFamily:'monospace', fontSize:12 }} />
            <p style={{ fontSize:11, color:'var(--muted)', marginTop:6 }}>Served at <code style={{ color:'var(--gold)' }}>/robots.txt</code></p>
          </div>
          <div style={{ padding:16, background:'var(--surface2)', borderRadius:8, border:'1px solid var(--border)' }}>
            <p style={{ fontSize:12, color:'var(--muted)', lineHeight:1.6 }}>
              Sitemap auto-generated at <a href="/sitemap.xml" target="_blank" style={{ color:'var(--gold)' }}>/sitemap.xml ↗</a> — includes all active gems, categories, and static pages.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   SLIDERS ADMIN
───────────────────────────────────────────── */
export function SlidersAdmin() {
  const [sliders,   setSliders]   = useState([]);
  const [editing,   setEditing]   = useState(null);
  const [form,      setForm]      = useState({ title:'', subtitle:'', cta_text:'', cta_link:'/shop', image_url:'', sort_order:0, is_active:true });
  const [saving,    setSaving]    = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileRef = React.useRef();

  const load = () => api.get('/admin/sliders').then(r => setSliders(r.data.data||[]));
  useEffect(() => { load(); }, []);

  const openNew  = () => { setEditing('new'); setForm({ title:'', subtitle:'', cta_text:'Explore', cta_link:'/shop', image_url:'', sort_order:sliders.length, is_active:true }); };
  const openEdit = s => { setEditing(s.id); setForm({...s, is_active:Boolean(s.is_active)}); };

  const handleImagePick = async e => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('image', file);
      const { data } = await api.post('/admin/upload/slider', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setForm(f => ({ ...f, image_url: data.url }));
      toast.success('Image uploaded');
    } catch { toast.error('Upload failed'); }
    finally { setUploading(false); e.target.value = ''; }
  };

  const save = async () => {
    if (!form.image_url) return toast.error('Please upload an image first');
    setSaving(true);
    try {
      if (editing === 'new') await api.post('/admin/sliders', form);
      else await api.put(`/admin/sliders/${editing}`, form);
      toast.success('Slider saved!'); setEditing(null); load();
    } catch { toast.error('Save failed'); }
    finally { setSaving(false); }
  };

  const del = async id => {
    if (!window.confirm('Delete this slide?')) return;
    await api.delete(`/admin/sliders/${id}`);
    toast.success('Deleted'); load();
  };

  return (
    <div style={{ fontFamily:'var(--font-sans)' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:28 }}>
        <div>
          <p style={{ fontSize:10.5, letterSpacing:'1.5px', textTransform:'uppercase', color:'var(--muted)', marginBottom:4, fontWeight:500 }}>Homepage</p>
          <h1 style={{ fontFamily:'var(--font-serif)', fontSize:34, fontWeight:400, letterSpacing:'-0.5px', color:'var(--white)', margin:0 }}>Hero Sliders</h1>
        </div>
        <button onClick={openNew} className="btn btn-gold">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add Slide
        </button>
      </div>

      {sliders.length === 0 && <p style={{ color:'var(--muted)', fontSize:14 }}>No slides yet. Add your first hero slide.</p>}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:20 }}>
        {sliders.map(s => (
          <div key={s.id} style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', overflow:'hidden', boxShadow:'var(--shadow-sm)' }}>
            <div style={{ position:'relative', paddingBottom:'52%', background:'var(--surface2)' }}>
              {s.image_url && <img src={s.image_url} alt={s.title} style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', filter:'brightness(0.72)' }} onError={e=>e.target.style.opacity=0.2} />}
              <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 60%)' }} />
              <div style={{ position:'absolute', top:10, right:10 }}>
                <span className={`badge ${s.is_active?'badge-success':'badge-muted'}`}>{s.is_active?'Active':'Hidden'}</span>
              </div>
              <div style={{ position:'absolute', bottom:10, left:12 }}>
                <p style={{ fontFamily:'var(--font-serif)', fontSize:15, color:'#fff', fontWeight:400 }}>{s.title||'(No title)'}</p>
              </div>
            </div>
            <div style={{ padding:'14px 18px' }}>
              <p style={{ fontSize:12, color:'var(--muted)', marginBottom:12, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.subtitle||'—'}</p>
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={()=>openEdit(s)} className="btn btn-outline btn-sm">Edit</button>
                <button onClick={()=>del(s.id)} className="btn btn-sm" style={{ border:'1px solid rgba(176,58,46,0.35)', color:'var(--danger)', padding:'6px 12px', borderRadius:6, fontSize:12 }}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing !== null && (
        <div className="modal-overlay" onClick={()=>setEditing(null)}>
          <div className="modal-box" onClick={e=>e.stopPropagation()} style={{ maxWidth:560 }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:22 }}>
              <h3 style={{ fontFamily:'var(--font-serif)', fontSize:22, color:'var(--white)', margin:0 }}>{editing==='new'?'Add Slide':'Edit Slide'}</h3>
              <button onClick={()=>setEditing(null)} style={{ color:'var(--muted)', fontSize:20 }}>✕</button>
            </div>

            {/* Image upload zone */}
            <div className="form-group">
              <label className="form-label">Hero Image</label>
              <input ref={fileRef} type="file" accept="image/*" onChange={handleImagePick} style={{ display:'none' }} />
              <div
                onClick={() => !uploading && fileRef.current.click()}
                style={{
                  border: `2px dashed ${form.image_url ? 'var(--gold)' : 'var(--border2)'}`,
                  borderRadius: 8, overflow:'hidden', cursor: uploading ? 'wait' : 'pointer',
                  position:'relative', minHeight: form.image_url ? 160 : 100,
                  display:'flex', alignItems:'center', justifyContent:'center',
                  transition:'border-color 0.2s',
                }}
                onMouseEnter={e => { if (!form.image_url) e.currentTarget.style.borderColor='var(--gold)'; }}
                onMouseLeave={e => { if (!form.image_url) e.currentTarget.style.borderColor='var(--border2)'; }}
              >
                {form.image_url ? (
                  <>
                    <img src={form.image_url} alt="" style={{ width:'100%', height:160, objectFit:'cover', display:'block' }} />
                    <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.45)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'opacity 0.2s' }}
                      onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0}>
                      <span style={{ color:'#fff', fontSize:12, letterSpacing:1.5, textTransform:'uppercase', fontWeight:500 }}>Change Image</span>
                    </div>
                  </>
                ) : (
                  <div style={{ textAlign:'center', padding:24 }}>
                    {uploading ? (
                      <div className="spinner" style={{ margin:'0 auto 10px' }} />
                    ) : (
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" style={{ margin:'0 auto 10px', display:'block' }}>
                        <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
                        <polyline points="21 15 16 10 5 21"/>
                      </svg>
                    )}
                    <p style={{ fontSize:13, color:'var(--muted)', marginBottom:4 }}>
                      {uploading ? 'Uploading…' : 'Click to upload image'}
                    </p>
                    <p style={{ fontSize:11, color:'var(--muted2)' }}>JPG, PNG, WebP · Max 10 MB</p>
                  </div>
                )}
              </div>
            </div>

            {[['title','Title','The Rarest Gems on Earth'],['subtitle','Subtitle','Description shown on hero'],['cta_text','Button Text','Explore Collection'],['cta_link','Button Link','/shop'],['sort_order','Sort Order','0']].map(([k,l,ph])=>(
              <div key={k} className="form-group"><label className="form-label">{l}</label>
                <input value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} className="form-input" placeholder={ph} type={k==='sort_order'?'number':'text'} />
              </div>
            ))}

            <label style={{ display:'flex', alignItems:'center', gap:10, marginBottom:20, cursor:'pointer' }}>
              <input type="checkbox" checked={Boolean(form.is_active)} onChange={e=>setForm({...form,is_active:e.target.checked})} style={{ accentColor:'var(--gold)' }} />
              <span style={{ fontSize:13, color:'var(--white)' }}>Active (visible on site)</span>
            </label>
            <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
              <button onClick={()=>setEditing(null)} className="btn btn-outline">Cancel</button>
              <button onClick={save} disabled={saving||uploading} className="btn btn-gold">{saving?'Saving…':'Save Slide'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   SETTINGS ADMIN
───────────────────────────────────────────── */
export function SettingsAdmin() {
  const [settings, setSettings] = useState({});
  const [saving,   setSaving]   = useState(false);

  useEffect(() => { api.get('/admin/settings').then(r => setSettings(r.data.data||{})); }, []);

  const v = key => settings[key]?.value || '';
  const s = key => val => setSettings(prev => ({ ...prev, [key]: { ...prev[key], value:val } }));

  const save = async () => {
    setSaving(true);
    const payload = {};
    Object.entries(settings).forEach(([k,v]) => { payload[k] = v.value||''; });
    try { await api.put('/admin/settings', payload); toast.success('Settings saved!'); }
    catch { toast.error('Save failed'); }
    finally { setSaving(false); }
  };

  const CARDS = [
    { title:'Store Details', keys:[['site_name','Site Name'],['site_tagline','Tagline'],['site_email','Contact Email'],['site_phone','Phone'],['site_whatsapp','WhatsApp'],['site_address','Showroom Address']] },
    { title:'Payments',      keys:[['stripe_public_key','Stripe Publishable Key'],['stripe_secret_key','Stripe Secret Key'],['default_currency','Currency'],['tax_rate','Tax Rate (%)']] },
    { title:'Shipping',      keys:[['shipping_free_from','Free Shipping From ($)'],['shipping_standard','Standard Shipping ($)'],['shipping_express','Express Shipping ($)']] },
    { title:'Notifications', keys:[['notify_new_order','New Order Email'],['notify_new_enquiry','New Enquiry Email'],['notify_low_stock','Low Stock Alerts'],['notify_revenue_digest','Daily Revenue Digest']] },
  ];

  return (
    <div style={{ fontFamily:'var(--font-sans)' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:28 }}>
        <div>
          <p style={{ fontSize:10.5, letterSpacing:'1.5px', textTransform:'uppercase', color:'var(--muted)', marginBottom:4, fontWeight:500 }}>Configuration</p>
          <h1 style={{ fontFamily:'var(--font-serif)', fontSize:34, fontWeight:400, letterSpacing:'-0.5px', color:'var(--white)', margin:0 }}>Site Settings</h1>
        </div>
        <button onClick={save} disabled={saving} className="btn btn-gold">{saving?'Saving…':'Save All Settings'}</button>
      </div>

      <div className="admin-form-grid" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
        {CARDS.map(({ title, keys }) => (
          <div key={title} style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:28, boxShadow:'var(--shadow-sm)' }}>
            <h3 style={{ fontFamily:'var(--font-serif)', fontSize:18, fontWeight:500, color:'var(--white)', marginBottom:22 }}>{title}</h3>
            {keys.map(([k, l]) => (
              <div key={k} className="form-group"><label className="form-label">{l}</label>
                <input value={v(k)} onChange={e=>s(k)(e.target.value)} className="form-input" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   ADMIN USERS
───────────────────────────────────────────── */
export function AdminUsers() {
  const [users,   setUsers]   = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [form,    setForm]    = useState({ name:'', email:'', password:'', role:'editor' });
  const [saving,  setSaving]  = useState(false);

  const load = () => api.get('/admin/users').then(r => setUsers(r.data.data||[]));
  useEffect(() => { load(); }, []);

  const addUser = async e => {
    e.preventDefault(); setSaving(true);
    try { await api.post('/admin/users', form); toast.success('User created'); setShowAdd(false); load(); setForm({name:'',email:'',password:'',role:'editor'}); }
    catch (err) { toast.error(err.response?.data?.message||'Failed'); }
    finally { setSaving(false); }
  };

  const toggleActive = async u => {
    await api.put(`/admin/users/${u.id}`, {...u, is_active:u.is_active?0:1});
    toast.success('User updated'); load();
  };

  const ROLE_BADGE = { super_admin:'badge-danger', admin:'badge-warning', editor:'badge-info' };
  const ROLE_LABEL = { super_admin:'Owner', admin:'Manager', editor:'Editor' };

  return (
    <div style={{ fontFamily:'var(--font-sans)' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:28 }}>
        <div>
          <p style={{ fontSize:10.5, letterSpacing:'1.5px', textTransform:'uppercase', color:'var(--muted)', marginBottom:4, fontWeight:500 }}>Access</p>
          <h1 style={{ fontFamily:'var(--font-serif)', fontSize:34, fontWeight:400, letterSpacing:'-0.5px', color:'var(--white)', margin:0 }}>Admin Users</h1>
        </div>
        <button onClick={()=>setShowAdd(true)} className="btn btn-gold">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Invite User
        </button>
      </div>

      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', overflow:'hidden', boxShadow:'var(--shadow-sm)' }}>
        <table>
          <thead><tr><th>User</th><th>Email</th><th>Role</th><th>Status</th><th>Last Active</th><th></th></tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td>
                  <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <div style={{ width:34, height:34, borderRadius:'50%', background:'linear-gradient(135deg, #c9a96e, #7a5d2c)', display:'flex', alignItems:'center', justifyContent:'center', color:'#0c0c10', fontWeight:700, fontSize:13, flexShrink:0 }}>
                      {u.name?.[0]?.toUpperCase()}
                    </div>
                    <p style={{ fontSize:13, color:'var(--white)', fontWeight:500 }}>{u.name}</p>
                  </div>
                </td>
                <td style={{ color:'var(--muted)', fontSize:12 }}>{u.email}</td>
                <td><span className={`badge ${ROLE_BADGE[u.role]||'badge-muted'}`}>{ROLE_LABEL[u.role]||u.role}</span></td>
                <td><span className={`badge ${u.is_active?'badge-success':'badge-muted'}`}>{u.is_active?'Active':'Inactive'}</span></td>
                <td style={{ color:'var(--muted)', fontSize:12 }}>{u.last_login?new Date(u.last_login).toLocaleDateString():'Never'}</td>
                <td>
                  <button onClick={()=>toggleActive(u)} style={{ fontSize:12, color:u.is_active?'var(--warning)':'var(--success)', background:'none', border:'none', cursor:'pointer', fontFamily:'var(--font-sans)' }}>
                    {u.is_active?'Deactivate':'Activate'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showAdd && (
        <div className="modal-overlay" onClick={()=>setShowAdd(false)}>
          <div className="modal-box" style={{ maxWidth:480 }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:22 }}>
              <h3 style={{ fontFamily:'var(--font-serif)', fontSize:22, color:'var(--white)', margin:0 }}>Add Admin User</h3>
              <button onClick={()=>setShowAdd(false)} style={{ color:'var(--muted)', fontSize:20 }}>✕</button>
            </div>
            <form onSubmit={addUser}>
              {[['name','Name','Full name'],['email','Email','admin@ceylongems.com'],['password','Password','Strong password']].map(([k,l,ph])=>(
                <div key={k} className="form-group"><label className="form-label">{l}</label>
                  <input required value={form[k]} onChange={e=>setForm({...form,[k]:e.target.value})} type={k==='password'?'password':'text'} className="form-input" placeholder={ph} />
                </div>
              ))}
              <div className="form-group"><label className="form-label">Role</label>
                <select value={form.role} onChange={e=>setForm({...form,role:e.target.value})} className="form-select">
                  <option value="editor">Editor</option>
                  <option value="admin">Admin</option>
                  <option value="super_admin">Super Admin</option>
                </select>
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                <button type="button" onClick={()=>setShowAdd(false)} className="btn btn-outline">Cancel</button>
                <button type="submit" disabled={saving} className="btn btn-gold">{saving?'Creating…':'Create User'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomersAdmin;
